var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkloadForecastThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.6863 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 75,
    width: 7,
    height: 52,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 84,
    width: 7,
    height: 43,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 64,
    width: 7,
    height: 63,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 75,
    width: 7,
    height: 52,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 31,
    width: 7,
    height: 96,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 37,
    width: 7,
    height: 90,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 53,
    width: 7,
    height: 74,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 66,
    width: 7,
    height: 61,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 54,
    width: 7,
    height: 73,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 60,
    width: 7,
    height: 67,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 39,
    width: 7,
    height: 88,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 45,
    width: 7,
    height: 82,
    rx: 2,
    fill: "#D1D1D1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 54,
    width: 7,
    height: 73,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 58,
    width: 7,
    height: 69,
    rx: 2,
    fill: "#D1D1D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadForecastThumbnail);
export default __webpack_public_path__ + "static/media/workload-forecast-thumbnail.c23f7e246eb5a2953fd330bc7af288bb.svg";
export { ForwardRef as ReactComponent };